module.exports = __webpack_public_path__ + "static/media/Calendar-3.93d3068c.png";